import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faVideo } from "@fortawesome/free-solid-svg-icons";
import { cn } from "@/utils/cn";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
const TemplateHero = ({ type, title, description, documents, videoDocuments, setDoctype, setVideoDoctype, templates, heroImage, selectedItem, updateSelectedItem, disable, isLoading }) => {
    const typeColorMap = {
        whats_changed_deep_dive: "bg-(--color-whats-changed-deep-dive)",
        whats_changed_overview: "bg-(--color-whats-changed-overview)",
        document_question_answering_and_chat: "bg-(--color-document-question-answering-and-chat)"
    };
    return (React.createElement("div", { className: "space-y-5 bg-[#F8FAFC] rounded-sm" },
        React.createElement("div", { className: cn(typeColorMap[type], "relative px-5 pt-5 rounded-sm") },
            React.createElement("div", { className: "bold text-xl mb-5" }, title),
            React.createElement("div", { className: "relative z-1" },
                React.createElement("img", { src: heroImage, alt: title, className: "w-full" })),
            React.createElement("div", { className: cn("absolute z-0 bottom-0 left-0 w-full bg-linear-to-br from-50% to-50% to-[#F8FAFC] h-10") })),
        React.createElement("div", { className: "px-5 space-y-5" },
            React.createElement("div", { className: "text-sm" }, description),
            React.createElement("div", { className: "flex space-x-6 items-center" },
                React.createElement("div", { className: "text-(--blueprint-text) space-x-1 flex items-center cursor-pointer hover:underline", onClick: () => setVideoDoctype(videoDocuments) },
                    React.createElement("div", null, "Video Overview"),
                    React.createElement(FontAwesomeIcon, { icon: faVideo })),
                React.createElement("div", { className: "text-(--blueprint-text) space-x-1 flex items-center cursor-pointer hover:underline", onClick: () => setDoctype(documents) },
                    React.createElement("div", null, "Read Documentation"),
                    React.createElement(FontAwesomeIcon, { icon: faBookOpen }))),
            React.createElement("div", { className: "mb-5 space-y-5" }, templates.map((template) => (React.createElement("div", { className: cn("border-1 bg-white p-2.5 rounded-sm flex gap-4 items-center cursor-pointer", selectedItem?.id === template.id ? "border-[#8556EB]" : "border-[#CBD5E1]", disable && "cursor-not-allowed bg-gray-100"), key: template.id, onClick: () => {
                    if (disable)
                        return;
                    updateSelectedItem(template.id);
                } },
                React.createElement("div", null,
                    React.createElement("img", { className: "w-[48px]", src: template.image, alt: template.title })),
                React.createElement("div", null,
                    React.createElement("div", { className: "bold text-base flex" },
                        template.title,
                        " ",
                        isLoading && (React.createElement(LoadingIndicator, { style: { width: "35px", height: "0px", transform: "scale(0.30)", margin: "0px" } }))),
                    React.createElement("div", null, template.description)))))))));
};
export default TemplateHero;
